import PresupuestosPromedioPrecios from './PresupuestosPromedioPrecios';

export default PresupuestosPromedioPrecios;
